/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable no-console */
import map from 'lodash/map';
import Quotations from '../../api/Quotations';
import BasicNotification from '../../shared/components/Notifications/BasicNotification';
import { saveAs } from 'file-saver';
import { closeSesion } from '../../helper/functions';
import { quotationsTypes } from '../types/quotations.types';
import { GET_DOCUMENT_FAILURE, GET_DOCUMENT_REQUEST, GET_DOCUMENT_SUCCESS } from '../../api/Types';

const errorMessages = {
  'QuotationAlreadySentTrinidad': 'Ya fue enviada la evaluacion.',
  'MissingClientFieldsToSend': 'Se necesitan los campos de correo y telefono del cliete para realizar la evaluación.',
  'MissingFieldsToSend': 'Se necesitan los campos de situación laboral, tipo de vehiculo y renta para realizar la evaluación.',
  'EmailAlreadyExists': 'El email ingresado ya está registrado en el sistema.',
  'RUTAlreadyExists': 'El rut ingresado ya está registrado en el sistema.',
  'ErrorTrinidad': 'Error al intentar evaluar al cliente (error trinidad).',
  'CaseIsClosed': 'No es posible agregar actividades a una cotización cerrado.',
};

export const getQuotationDataExport = (data, cb) => async (dispatch) => {
  try {
    dispatch({ type: quotationsTypes.GET_EXPORT_DATA_REQUEST });
    const { body } = await Quotations.getQuotationDataExport(data);
    if (cb) {
      cb(body);
    }
    dispatch({ type: quotationsTypes.GET_EXPORT_DATA_SUCCESS, payload: { body } });
  } catch (error) {
    dispatch({ type: quotationsTypes.GET_EXPORT_DATA_FAILED, payload: { error } });
    BasicNotification.error('Ocurrió un error al intentar obtener la data a exportar.');
  }
};

export const getExcelQuotationToExport = (data, cb) => async (dispatch) => {
  const { fromDateQuotation, toDateQuotation } = data;
  try {
    dispatch({ type: quotationsTypes.GET_EXPORT_QUOTATIONS_REQUEST });
    const { body } = await Quotations.getExcelQuotationToExport(data);
    saveAs(body, `quotations_${fromDateQuotation}${toDateQuotation}`);
    if (cb) {
      cb(body);
    }
    dispatch({ type: quotationsTypes.GET_EXPORT_QUOTATIONS_SUCCESS, payload: { body } });
  } catch (error) {
    dispatch({ type: quotationsTypes.GET_EXPORT_QUOTATIONS_FAILED, payload: { error } });
    BasicNotification.error('Ocurrió un error al intentar obtener la data a exportar.');
  }
};

export const getQuotationsSummary = (query, cb) => async (dispatch) => {
  dispatch({ type: quotationsTypes.GET_SUMMARY_QUOTATIONS, loadingQuotationsSummary: true });
  try {
    const { body } = await Quotations.getQuotatioSummary(query);
    if (cb) {
      cb(body);
    }
    dispatch({ type: quotationsTypes.GET_SUMMARY_QUOTATIONS_SUCCESS, loadingQuotationsSummary: false, payload: { summary: body } });
  } catch (error) {
    dispatch({ type: quotationsTypes.GET_SUMMARY_QUOTATIONS_FAILED, loadingQuotationsSummary: false, payload: { error } });
    if (error.status === 403) {
      BasicNotification.error('No tienes permisos para ver los casos.');
    } else {
      console.error(error);
      BasicNotification.error('Ocurrió un error al intentar obtener el summary de cotizaciones.');
    }
  }
};

export const getSignedDocumentQuotation = (id, cb) => async (dispatch) => {
  dispatch({ type: GET_DOCUMENT_REQUEST, loading: true });
  try {
    const { text } = await Quotations.getSignedDocumentQuotation(id);
    if (cb) {
      cb(text);
    }
    dispatch({ type: GET_DOCUMENT_SUCCESS, loading: false, payload: { doc: text } });
  } catch (error) {
    dispatch({ type: GET_DOCUMENT_FAILURE, loading: false, payload: { error } });
    if (error.status === 403) {
      BasicNotification.error('No tienes permisos para ver el documento.');
    }
  }
};


export const getExcelQuotations = (fromDate, toDate, cb) => async (dispatch) => {
  dispatch({ type: quotationsTypes.GET_EXCEL_QUOTATION });
  try {
    const { body } = await Quotations.getExcelQuotations(fromDate, toDate);
    saveAs(body, `quotations_${fromDate}${toDate}`);
    if (cb) {
      cb(body);
    }
    dispatch({ type: quotationsTypes.GET_EXCEL_QUOTATION_SUCCESS, payload: { body } });
  } catch (error) {
    dispatch({ type: quotationsTypes.GET_EXCEL_QUOTATION_FAILED, payload: { error } });
    if (error) {
      BasicNotification.error('Ocurrió un erro al obtener el excel.');
    }
  }
};

export const getAllQuotations = (query, cb) => async (dispatch) => {
  dispatch({ type: quotationsTypes.GET_ALL_QUOTATIONS, cargando: true });
  try {
    const { body, header } = await Quotations.getAllQuotations(query || '');
    const countQuotations = header['x-pagination-total-count'];
    const limitQuotations = header['x-pagination-limit'];
    if (cb) {
      cb(body);
    }
    dispatch({
      type: quotationsTypes.GET_ALL_QUOTATIONS_SUCCESS,
      payload: { allQuotations: body, countQuotations, limitQuotations },
    });
  } catch (error) {
    dispatch({ type: quotationsTypes.GET_ALL_QUOTATIONS_FAILED, cargando: false, payload: { error } });
    if (error.status === 401) {
      console.error(error);
      closeSesion();
    }
  }
};

export const getConcessionaires = (cb) => async (dispatch) => {
  dispatch({ type: quotationsTypes.GET_CONCESSIONAIRES, loading: true });
  try {
    const { body } = await Quotations.getConcessionaires();
    if (cb) {
      cb(body);
    }
    dispatch({
      type: quotationsTypes.GET_CONCESSIONAIRES_SUCCESS,
      payload: { ces: body.body, loading: false },
    });
  } catch (error) {
    dispatch({ type: quotationsTypes.GET_CONCESSIONAIRES_FAILED, loading: false, payload: { error } });
    if (error.status === 401) {
      console.error(error);
      closeSesion();
    }
    if (error.status === 404) {
      console.log('404 not found', error.response.body);
    }
  }
};


export const getAllQuotationsDashboard = (query, cb) => async (dispatch) => {
  dispatch({ type: quotationsTypes.GET_ALL_QUOTATIONS_DASHBOARD });
  try {
    const { body } = await Quotations.getAllQuotationsDashboard(query || '');
    if (cb) {
      cb(body);
    }
    dispatch({ type: quotationsTypes.GET_ALL_QUOTATIONS_DASHBOARD_SUCCESS, payload: body });
  } catch (error) {
    dispatch({ type: quotationsTypes.GET_ALL_QUOTATIONS_DASHBOARD_FAILED, payload: { error } });
    if (error.status === 401) {
      console.error(error);
      closeSesion();
    }
  }
};

export const getAllQuotationsMe = (query, cb) => async (dispatch) => {
  dispatch({ type: quotationsTypes.GET_ALL_QUOTATIONS, cargando: true });
  try {
    const { body, header } = await Quotations.getAllQuotationsMe(query || '');
    const countQuotations = header['x-pagination-total-count'];
    const limitQuotations = header['x-pagination-limit'];
    if (cb) {
      cb(body);
    }
    dispatch({
      type: quotationsTypes.GET_ALL_QUOTATIONS_SUCCESS,
      payload: { allQuotations: body, countQuotations, limitQuotations },
    });
  } catch (error) {
    dispatch({ type: quotationsTypes.GET_ALL_QUOTATIONS_FAILED, cargando: false, payload: { error } });
    if (error.status === 401) {
      console.error(error);
      closeSesion();
    }
  }
};

export const getQuotationById = (id, cb) => async (dispatch) => {
  dispatch({ type: quotationsTypes.GET_QUOTATIONS_ID, loadingQuotations: true });
  try {
    const { body } = await Quotations.getQuotationById(id);
    if (cb) {
      cb(body);
    }
    dispatch({ type: quotationsTypes.GET_QUOTATIONS_ID_SUCCESS, loadingQuotations: false, payload: { quotationInfo: body } });
  } catch (error) {
    dispatch({ type: quotationsTypes.GET_QUOTATIONS_ID_FAILED, loadingQuotations: false, payload: { error } });
    if (error.status === 403) {
      BasicNotification.error('No tienes permisos para ver la cotización selccionado.');
    } else {
      console.error(error);
      BasicNotification.error('Ocurrió un error al intentar obtener los datos de la cotización');
    }
  }
};

export const getQuotationByIdMe = (id, cb) => async (dispatch) => {
  dispatch({ type: quotationsTypes.GET_QUOTATIONS_ID, loadingQuotations: true });
  try {
    const { body } = await Quotations.getQuotationByIdMe(id);
    if (cb) {
      cb(body);
    }
    dispatch({ type: quotationsTypes.GET_QUOTATIONS_ID_SUCCESS, loadingQuotations: false, payload: { quotationInfo: body } });
  } catch (error) {
    dispatch({ type: quotationsTypes.GET_QUOTATIONS_ID_FAILED, loadingQuotations: false, payload: { error } });
    if (error.status === 403) {
      BasicNotification.error('No tienes permisos para ver la cotización selccionado.');
    } else {
      console.error(error);
      BasicNotification.error('Ocurrió un error al intentar obtener los datos de la cotización');
    }
  }
};

export const updateQuotationMany = (data, cb) => async (dispatch) => {
  dispatch({ type: quotationsTypes.UPDATE_QUOTATION_MANY, cargando: true });
  BasicNotification.info('Reasignando Cotizaciones...');
  try {
    const { status } = await Quotations.updateQuotationMany(data);
    if (cb) {
      cb(status);
    }
    dispatch({ type: quotationsTypes.UPDATE_QUOTATION_MANY_SUCCESS, cargando: false });
    BasicNotification.success('Cotizaciones reasignadas con éxito.');
  } catch (error) {
    dispatch({ type: quotationsTypes.UPDATE_QUOTATION_MANY_FAILED, cargando: false, payload: { error } });
    let defaultError = 'Ocurrió un error al intentar reasignar Cotizaciones';
    BasicNotification.error(error?.response?.body?.message || defaultError);
  }
};

export const updateQuotations = (id, data, cb) => async (dispatch) => {
  dispatch({ type: quotationsTypes.UPDATE_QUOTATIONS, cargando: true });
  if (data.action === 'sendToTrinidad') {
    BasicNotification.info('Enviando evaluación...');
  } else {
    BasicNotification.info('Actualizando cotización...');
  }
  try {
    if (data.action === 'addMessage') {
      const formData = new FormData();
      formData.append('action', data.action);
      formData.append('body', data.body);
      if (data.attachments) {
        map(data.attachments, (file) => {
          formData.append('attachments', file);
        });
      }
      data = formData;
    }
    const { status } = await Quotations.updateQuotations(id, data);
    if (cb) cb(status);
    dispatch({ type: quotationsTypes.UPDATE_QUOTATIONS_SUCCESS, cargando: false });
    if ((data.action === 'sendToTrinidad')) {
      BasicNotification.success('Evaluación enviada con éxito.');
    } else {
      BasicNotification.success('Cotización actualizada con éxito.');
    }
  } catch (error) {
    dispatch({ type: quotationsTypes.UPDATE_QUOTATIONS_FAILED, cargando: false, payload: { error } });
    if (error.status === 401) {
      closeSesion();
    } else if (error.status === 400) {
      const message = errorMessages[error?.response?.body?.code || ''];
      if (message) {
        BasicNotification.error(message);
      } else {
        BasicNotification.error('Error al intentar crear la actividad');
      }
    }
  }
};

export const updateQuotationsMe = (id, data, cb) => async (dispatch) => {
  dispatch({ type: quotationsTypes.UPDATE_QUOTATIONS, cargando: true });
  BasicNotification.info('Actualizando cotización...');
  try {
    if (data.action === 'addMessage') {
      const formData = new FormData();
      formData.append('action', data.action);
      formData.append('body', data.body);
      if (data.attachments) {
        map(data.attachments, (file) => {
          formData.append('attachments', file);
        });
      }
      data = formData;
    }
    await Quotations.updateQuotationsMe(id, data);
    if (cb) {
      cb();
    }
    dispatch({ type: quotationsTypes.UPDATE_QUOTATIONS_SUCCESS, cargando: false });
    BasicNotification.success('Cotizacion actualizada con éxito.');
  } catch (error) {
    console.error(error);
    if (error.status === 401) { closeSesion(); }
    if (error.status === 400 && error.response.body.code === 'CaseIsClosed') {
      dispatch({ type: quotationsTypes.UPDATE_QUOTATIONS_FAILED, cargando: false, payload: { error } });
      BasicNotification.error('No es posible agregar actividades a una cotización cerrado.');
    }
    if (error.status === 400 && error.response.body.code === 'ErrorTrinidad') {
      dispatch({ type: quotationsTypes.UPDATE_QUOTATIONS_FAILED, cargando: false, payload: { error } });
      BasicNotification.error('Error al intentar evaluar al cliente (error trinidad).');
    }
  }
};


export const deleteQuotations = (id, cb) => async (dispatch) => {
  dispatch({ type: quotationsTypes.DELETE_QUOTATIONS });
  BasicNotification.info('Eliminado Cotización...');
  try {
    await Quotations.removeQuotationsById(id);
    if (cb) {
      cb();
    }
    dispatch({ type: quotationsTypes.DELETE_QUOTATIONS_SUCCESS });
    BasicNotification.success('Cotización eliminada con éxito.');
  } catch (error) {
    dispatch({ type: quotationsTypes.DELETE_QUOTATIONS_FAILED });
    console.error(error);
    BasicNotification.error('Ocurrió un error al intentar eliminar la Cotización');
  }
};

export const createQuotations = (data, cb) => async (dispatch) => {
  dispatch({ type: quotationsTypes.CREATE_QUOTATIONS, loadingCreateQ: true });
  try {
    BasicNotification.info('Creando cotización...');
    const { body } = await Quotations.createQuotations(data);
    if (cb) {
      cb(body);
    }
    dispatch({ type: quotationsTypes.CREATE_QUOTATIONS_SUCCESS, payload: { quotation: body }, loadingCreateQ: false });
    BasicNotification.success('Cotización creada con éxito.');
  } catch (error) {
    console.error(error);
    if (error.status === 401) { closeSesion(); } else {
      BasicNotification.error('Ocurrió un error al intentar crear la cotización.');
    }
    dispatch({ type: quotationsTypes.CREATE_QUOTATIONS_FAILED, error, loadingCreateQ: false });
  }
};



export const createQuotationsMe = (data, cb) => async (dispatch) => {
  dispatch({ type: quotationsTypes.CREATE_QUOTATIONS, loadingCreateQ: true });
  try {
    BasicNotification.info('Creando cotización...');
    const { body } = await Quotations.createQuotationsMe(data);
    if (cb) {
      cb(body);
    }
    dispatch({ type: quotationsTypes.CREATE_QUOTATIONS_SUCCESS, payload: { quotation: body }, loadingCreateQ: false });
    BasicNotification.success('Cotización creada con éxito.');
  } catch (error) {
    if (error.status === 401) {
      closeSesion();
    } else if (error.status === 409) {
      const message = errorMessages[error?.response?.body?.code || ''];
      if (message) {
        BasicNotification.error(message);
      } else {
        BasicNotification.error('Ocurrió un error al intentar crear el usuario');
      }
    }
    dispatch({ type: quotationsTypes.CREATE_QUOTATIONS_FAILED, error, loadingCreateQ: false });
  }
};